import { render, staticRenderFns } from "./BrandKeypoint.vue?vue&type=template&id=1a7e4ef2&scoped=true&"
import script from "./BrandKeypoint.vue?vue&type=script&lang=js&"
export * from "./BrandKeypoint.vue?vue&type=script&lang=js&"
import style0 from "./BrandKeypoint.vue?vue&type=style&index=0&id=1a7e4ef2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7e4ef2",
  null
  
)

export default component.exports